import Finalize from "pages/Finalize/Finalize";

export const RegistrationFinalize = () => (
    <Finalize type="web-finalize" />
)


